import { useState } from "react";
import { KYCModalPaging } from "@features/KnowYourCustomerModal/components/KYCModalPaging/KYCModalPaging";
import { useApiErrorUtils } from "@hooks/useApiErrorUtils";
import { submitPreviousFormData } from "@services/knowYourCustomer/services";
import {
  KycFormStep,
  type TAuthenticationFormType,
} from "@services/knowYourCustomer/types";
import { isNullOrUndefined } from "@utils/common";
import { AuthenticationDataForm } from "./components/AuthenticationDataForm/AuthenticationDataForm";
import { AuthenticationTypeForm } from "./components/AuthenticationTypeForm/AuthenticationTypeForm";

interface IKnowYourCustomerAuthenticationProps {
  onSuccess: () => void;
  authPurpose: "identification" | "signDocument";
  onChangeStep: (step: KycFormStep) => void;
}

export const KnowYourCustomerAuthentication: React.FC<
  IKnowYourCustomerAuthenticationProps
> = ({ onSuccess, authPurpose, onChangeStep }) => {
  const [step, setStep] =
    useState<TAuthenticationFormType>("authenticationType");

  const { toastApiError } = useApiErrorUtils();

  const goBack = async () => {
    const step = await submitPreviousFormData().catch(toastApiError);

    if (!isNullOrUndefined(step)) {
      onChangeStep?.(step);
    }
  };

  return (
    <div className="flex flex-col gap-6">
      {step === "authenticationType" && (
        <KYCModalPaging
          currentStep={KycFormStep.IDENTIFICATION_FORM}
          onPreviousButtonClick={goBack}
        />
      )}
      {step === "authenticationType" && (
        <AuthenticationTypeForm
          setStep={setStep}
          authPurpose={authPurpose}
          onSuccess={onSuccess}
        />
      )}
      {(step === "smartId" || step === "mobileId" || step === "biometric") && (
        <AuthenticationDataForm
          authenticationType={step}
          authPurpose={authPurpose}
          setStep={setStep}
          onAuthentication={onSuccess}
          onCancel={() => setStep("authenticationType")}
        />
      )}
    </div>
  );
};
